(function () {
  const root = document.querySelector('[data-qp-exit-survey]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const dialog = root.querySelector('[data-qp-survey-dialog]');
  const closeButton = root.querySelector('[data-qp-survey-close]');
  const question = root.querySelector('[data-qp-survey-question]');
  const thanks = root.querySelector('[data-qp-survey-thanks]');
  const reasonButtons = Array.from(root.querySelectorAll('[data-qp-survey-reason]'));
  const customAnswer = root.querySelector('[data-qp-survey-custom]');
  const submitButton = root.querySelector('[data-qp-survey-submit]');
  const validationMessage = root.querySelector('[data-qp-survey-validation]');
  const triggerDelay = Math.max(0, Number(root.dataset.triggerDelay) || 0);
  const attemptStorageKey = 'gm_checkout_exit_attempt_v3';
  const legacyAttemptStorageKey = 'gm_qp_checkout_attempt_v2';
  const lastShownStorageKey = 'checkoutExitSurveyLastShownAt';
  const surveyCooldownMs = 10800000;
  const attemptMaxAgeMs = 86400000;
  const responseEndpoint =
    'https://docs.google.com/forms/d/e/1FAIpQLSejjI9hx4vKiQx-vvsS2k-Xe5x4FXmhhRGthDnR967DK4lYXA/formResponse';
  const responseReasonField = 'entry.2126520443';
  const responseCustomField = 'entry.728952771';
  const responseContextField = 'entry.2093528003';
  const responseLabels = {
    unsure_it_works: "I'm not sure it will work for me",
    price_or_total: 'The price or total was higher than expected',
    bundle_unclear: "The bundle or quantity wasn't clear",
    shipping: 'I need more shipping information',
    comfort: "I'm unsure about comfort or the pulse",
    trust: 'I need more trust or return information',
    technical_problem: "Something didn't work",
    just_browsing: 'I was just browsing',
  };
  const cartUrl = `${window.Shopify?.routes?.root || '/'}cart.js`;
  let cartSnapshot = null;
  let pendingAttemptId = '';
  let selectedReason = '';
  let triggerTimer = 0;
  let returnCheckRunning = false;
  let lastShownAtMemory = 0;

  if (typeof HTMLDialogElement === 'undefined' || !(dialog instanceof HTMLDialogElement)) return;

  function trackEvent(name) {
    if (typeof window.clarity === 'function') window.clarity('event', name);
  }

  function setTag(key, value) {
    if (typeof window.clarity === 'function') window.clarity('set', key, value);
  }

  function readAttempt() {
    try {
      const attempt = JSON.parse(localStorage.getItem(attemptStorageKey) || 'null');
      if (!attempt?.startedAt || Date.now() - Number(attempt.startedAt) > attemptMaxAgeMs) {
        localStorage.removeItem(attemptStorageKey);
        return null;
      }
      return attempt;
    } catch (_error) {
      return null;
    }
  }

  function writeAttempt(attempt) {
    try {
      localStorage.setItem(attemptStorageKey, JSON.stringify(attempt));
    } catch (_error) {}
  }

  function clearAttempt() {
    pendingAttemptId = '';
    try {
      localStorage.removeItem(attemptStorageKey);
      sessionStorage.removeItem(legacyAttemptStorageKey);
    } catch (_error) {}
  }

  function readLastShownAt() {
    try {
      const storedValue = Number(localStorage.getItem(lastShownStorageKey));
      if (Number.isFinite(storedValue) && storedValue > 0) lastShownAtMemory = storedValue;
    } catch (_error) {}
    return lastShownAtMemory;
  }

  function writeLastShownAt(timestamp) {
    lastShownAtMemory = timestamp;
    try {
      localStorage.setItem(lastShownStorageKey, String(timestamp));
    } catch (_error) {}
  }

  function isSurveyOnCooldown(now = Date.now()) {
    const lastShownAt = readLastShownAt();
    return lastShownAt > 0 && now - lastShownAt < surveyCooldownMs;
  }

  async function fetchCart() {
    const response = await fetch(cartUrl, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error(`Unable to read cart: ${response.status}`);
    return response.json();
  }

  function syncCartSnapshot() {
    return fetchCart()
      .then((cart) => {
        cartSnapshot = cart;
        return cart;
      })
      .catch(() => null);
  }

  function resetSurveyForm() {
    selectedReason = '';
    reasonButtons.forEach((button) => {
      button.setAttribute('aria-pressed', 'false');
      button.classList.remove('is-selected');
    });
    if (customAnswer) customAnswer.value = '';
    if (validationMessage) validationMessage.hidden = true;
  }

  function openSurvey() {
    triggerTimer = 0;
    if (dialog.open || isSurveyOnCooldown()) return;
    if (document.visibilityState !== 'visible') {
      document.addEventListener('visibilitychange', openSurvey, { once: true });
      return;
    }
    writeLastShownAt(Date.now());
    resetSurveyForm();
    question.hidden = false;
    thanks.hidden = true;
    dialog.showModal();
    setTag('checkout_exit_survey', 'shown');
    trackEvent('checkout_exit_survey_shown');
    requestAnimationFrame(() => reasonButtons[0]?.focus());
  }

  function scheduleSurvey() {
    window.clearTimeout(triggerTimer);
    triggerTimer = window.setTimeout(openSurvey, triggerDelay);
  }

  function dismissSurvey() {
    if (!dialog.open) return;
    setTag('checkout_exit_survey', 'dismissed');
    trackEvent('checkout_exit_survey_dismissed');
    clearAttempt();
    dialog.close();
  }

  function selectReason(reason, button) {
    selectedReason = reason;
    reasonButtons.forEach((reasonButton) => {
      const isSelected = reasonButton === button;
      reasonButton.setAttribute('aria-pressed', String(isSelected));
      reasonButton.classList.toggle('is-selected', isSelected);
    });
    if (validationMessage) validationMessage.hidden = true;
  }

  function buildResponseContext() {
    const attempt = readAttempt();
    const context = {
      checkoutEntry: attempt?.entryMethod || 'unknown',
      sourcePath: attempt?.sourcePath || '',
      sourceProduct: attempt?.sourceProduct || '',
      returnPath: `${window.location.pathname}${window.location.search}`,
      device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
    };
    return Object.entries(context)
      .filter(([, value]) => value)
      .map(([key, value]) => `${key}: ${value}`)
      .join(' | ');
  }

  function submitSurvey() {
    const customText = String(customAnswer?.value || '').trim();
    if (!selectedReason && !customText) {
      if (validationMessage) validationMessage.hidden = false;
      (customAnswer || reasonButtons[0])?.focus();
      return;
    }

    const responseLabel = responseLabels[selectedReason] || '';
    const context = buildResponseContext();
    const payload = new URLSearchParams();
    if (responseLabel) payload.set(responseReasonField, responseLabel);
    if (customText) payload.set(responseCustomField, customText);
    if (context) payload.set(responseContextField, context);

    setTag('checkout_exit_survey', 'answered');
    setTag('checkout_exit_reason', selectedReason || 'custom_only');
    setTag('checkout_exit_has_custom_text', customText ? 'yes' : 'no');
    trackEvent('checkout_exit_survey_answered');
    trackEvent(`checkout_exit_reason_${selectedReason || 'custom_only'}`);

    fetch(responseEndpoint, {
      method: 'POST',
      mode: 'no-cors',
      keepalive: true,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: payload,
    }).catch(() => {});

    window.dispatchEvent(
      new CustomEvent('gm:checkout-exit-survey-submitted', {
        detail: { reason: selectedReason, customText, context },
      })
    );
    clearAttempt();
    question.hidden = true;
    thanks.hidden = false;
    thanks.focus();
    window.setTimeout(() => dialog.open && dialog.close(), 1400);
  }

  function isCheckoutUrl(value) {
    try {
      const url = new URL(value, window.location.href);
      return /\/checkouts?(?:\/|$)/i.test(url.pathname) || /(^|\.)checkout\.shopify\.com$/i.test(url.hostname);
    } catch (_error) {
      return false;
    }
  }

  function entryMethodFromPath(path) {
    const elements = path.filter((node) => node instanceof Element);
    const directCheckout = elements.some((element) =>
      element.matches(
        'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, shopify-buy-it-now-button, .shopify-payment-button, .shopify-payment-button__button, [data-shopify="payment-button"], [data-buy-now]'
      )
    );
    if (directCheckout) return 'direct_checkout';

    for (const element of elements) {
      const href = element instanceof HTMLAnchorElement ? element.href : element.getAttribute('href');
      if (href && isCheckoutUrl(href)) return 'checkout_link';
      if (element.matches('[name="checkout"], [formaction*="/checkout"]')) return 'cart_checkout';
    }
    return '';
  }

  function beginCheckoutAttempt(entryMethod) {
    const existingAttempt = readAttempt();
    if (existingAttempt && !existingAttempt.departed && Date.now() - Number(existingAttempt.startedAt) < 3000) return;

    const attempt = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      startedAt: Date.now(),
      departed: false,
      entryMethod: entryMethod || 'checkout',
      sourcePath: `${window.location.pathname}${window.location.search}`,
      sourceProduct: root.dataset.currentProductHandle || '',
      sourceTemplate: root.dataset.currentTemplate || '',
      cartItemCountBefore: Number.isFinite(Number(cartSnapshot?.item_count)) ? Number(cartSnapshot.item_count) : null,
      cartTokenBefore: cartSnapshot?.token || '',
    };
    pendingAttemptId = attempt.id;
    writeAttempt(attempt);
    setTag('checkout_exit_survey', 'checkout_started');
    setTag('checkout_exit_entry_method', attempt.entryMethod);
    trackEvent('checkout_exit_checkout_started');
  }

  function markCheckoutDeparted() {
    if (!pendingAttemptId) return;
    const attempt = readAttempt();
    if (!attempt || attempt.id !== pendingAttemptId) return;
    attempt.departed = true;
    attempt.departedAt = Date.now();
    writeAttempt(attempt);
  }

  function returnedFromCompletedOrder() {
    if (!document.referrer) return false;
    try {
      const referrer = new URL(document.referrer);
      return /\/(?:checkouts?\/.*\/(?:thank[-_]?you|post_purchase)|orders\/)/i.test(referrer.pathname);
    } catch (_error) {
      return false;
    }
  }

  async function checkForCheckoutReturn() {
    if (returnCheckRunning) return;
    const attempt = readAttempt();
    if (!attempt?.departed) return;

    if (attempt.surveyScheduled) {
      if (isSurveyOnCooldown()) clearAttempt();
      else scheduleSurvey();
      return;
    }

    returnCheckRunning = true;
    try {
      if (returnedFromCompletedOrder()) {
        clearAttempt();
        trackEvent('checkout_exit_purchase_detected');
        return;
      }

      const cart = await fetchCart();
      cartSnapshot = cart;
      const startedWithCartItems = Number(attempt.cartItemCountBefore) > 0;
      const cartWasCleared = startedWithCartItems && Number(cart.item_count) === 0;
      if (cartWasCleared) {
        clearAttempt();
        trackEvent('checkout_exit_purchase_detected');
        return;
      }

      const onCooldown = isSurveyOnCooldown();
      if (onCooldown) {
        clearAttempt();
        return;
      }
      attempt.returnedAt = Date.now();
      attempt.surveyScheduled = true;
      pendingAttemptId = '';
      writeAttempt(attempt);
      setTag('checkout_exit_survey', 'returned_without_purchase');
      trackEvent('checkout_exit_returned');
      scheduleSurvey();
    } catch (_error) {
      // Keep the attempt so the next storefront page can retry.
    } finally {
      returnCheckRunning = false;
    }
  }

  function detectCheckoutIntent(event) {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const entryMethod = entryMethodFromPath(path);
    if (entryMethod) beginCheckoutAttempt(entryMethod);
  }

  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (!event.promise) return;
    event.promise.then(syncCartSnapshot).catch(() => {});
  });

  document.addEventListener('pointerdown', detectCheckoutIntent, true);
  document.addEventListener('click', detectCheckoutIntent, true);
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      const submitter = event.submitter instanceof Element ? event.submitter : null;
      const action = submitter?.getAttribute('formaction') || form?.action || '';
      if (submitter?.matches('[name="checkout"]') || isCheckoutUrl(action)) {
        beginCheckoutAttempt(submitter?.matches('[name="checkout"]') ? 'cart_checkout' : 'checkout_form');
      }
    },
    true
  );

  window.addEventListener('pagehide', markCheckoutDeparted);
  window.addEventListener('pageshow', checkForCheckoutReturn);

  reasonButtons.forEach((button) => {
    button.addEventListener('click', () => selectReason(button.dataset.qpSurveyReason || '', button));
  });
  customAnswer?.addEventListener('input', () => {
    if (validationMessage && customAnswer.value.trim()) validationMessage.hidden = true;
  });
  submitButton?.addEventListener('click', submitSurvey);
  closeButton?.addEventListener('click', dismissSurvey);

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    dismissSurvey();
  });
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dismissSurvey();
  });

  try {
    sessionStorage.removeItem(legacyAttemptStorageKey);
  } catch (_error) {}
  syncCartSnapshot();
  checkForCheckoutReturn();
})();
